import { render, staticRenderFns } from "./MyLayout.vue?vue&type=template&id=1a687620&scoped=true"
import script from "./MyLayout.vue?vue&type=script&lang=js"
export * from "./MyLayout.vue?vue&type=script&lang=js"
import style0 from "./MyLayout.vue?vue&type=style&index=0&id=1a687620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a687620",
  null
  
)

export default component.exports